import React, { useRef } from 'react';
import { formatDoctorName } from '../../../../utils/common';
import { CardCloseSVG } from './CardViewSVG';
import {
  ProviderImageMen,
  ProviderImageWomen,
  ProviderImageUnknownGender,
  FacilityIcon,
} from '../../../../img/findcare/FindCareSVG';
import { useSelector, useDispatch } from 'react-redux';
import {
  setSelectedCheckedItems,
  setSelectedCheckedRowData,
} from '../../../../../redux/member/priceCompareSlice';
import './CardView.scss';

const CardView = ({ data, index, tableRef, cardRefs }) => {
  console.log('CardView', data);
  const {
    DoctorTitle,
    LastName,
    FirstName,
    MiddleName,
    Suffix,
    Gender,
    Specialties,
    PhysicianID,
    Experiance,
    ConnectorId,
    FacilityName,
    FacilitySpeciality,
  } = data;
  const dispatch = useDispatch();
  const { selectedCheckedItems, selectedCheckedRowData } = useSelector(
    ({ priceCompare }) => priceCompare,
  );
  const allFilters = useSelector(
    ({ priceCompare }) => priceCompare.searchProviderParams.filters,
  );
  const { Provider } = allFilters;
  const removeItem = (phyId) => {
    dispatch(
      setSelectedCheckedItems(
        selectedCheckedItems.filter((id) => id !== phyId),
      ),
    );
    dispatch(
      setSelectedCheckedRowData(
        selectedCheckedRowData.filter((item) => item.ConnectorId !== phyId),
      ),
    );
    //console.log('cardRefs', cardRefs.current[0].current);
    //For Accessibility start
    if (cardRefs.current[0].current) {
      cardRefs.current[0].current.focus();
      setTimeout(() => {
        if (cardRefs.current[0].current !== null) {
          cardRefs.current[0].current.blur();
        } else {
          if (tableRef && tableRef?.current) {
            tableRef?.current.focus();
            setTimeout(() => {
              tableRef?.current.blur();
            }, 1000);
          }
        }
      }, 1000);
    }
    //For Accessibility end
  };

  return (
    <div className="card-container">
      <div
        className="sr-only"
        role="none"
        tabIndex={-1}
        ref={cardRefs.current[index]}
      >
        Provider Name is{' '}
        {Provider === 'facility' ? (
          <span>{FacilityName}</span>
        ) : (
          <span>
            {formatDoctorName(
              DoctorTitle ? DoctorTitle : '',

              LastName ? LastName : '',

              FirstName ? FirstName : '',

              MiddleName ? MiddleName : '',

              Suffix ? Suffix : '',
            )}
          </span>
        )}
      </div>
      <div
        aria-label="Remove this provider from the selected options"
        className="close-icon"
        onClick={() => {
          removeItem(ConnectorId);
        }}
      >
        <CardCloseSVG />
      </div>

      <div className="card-view">
        <div className="content-container">
          <div>
            {Provider === 'facility' ? (
              <FacilityIcon
                className="image-color"
                circleClassName="circle-color"
              />
            ) : (
              <>
                {Gender === 'Male' && (
                  <ProviderImageMen
                    className="image-color"
                    circleClassName="circle-color"
                  />
                )}

                {Gender === 'Female' && (
                  <ProviderImageWomen
                    className="image-color"
                    circleClassName="circle-color"
                  />
                )}

                {(!Gender?.trim() || Gender?.trim() === 'Unknown') && (
                  <ProviderImageUnknownGender
                    className="image-color"
                    circleClassName="circle-color"
                  />
                )}
              </>
            )}
          </div>

          <div className="ml-3 column-last">
            {Provider === 'facility' ? (
              <p className="m-0 provider-name">{FacilityName}</p>
            ) : (
              <p className="m-0 provider-name">
                {formatDoctorName(
                  DoctorTitle ? DoctorTitle : '',

                  LastName ? LastName : '',

                  FirstName ? FirstName : '',

                  MiddleName ? MiddleName : '',

                  Suffix ? Suffix : '',
                )}
              </p>
            )}

            <p className="m-0 provider-spacality">
              {Provider === 'facility'
                ? FacilitySpeciality && FacilitySpeciality.join(', ')
                : Specialties && Specialties.join(', ')}
            </p>

            <p className="m-0 provider-experience">
              {Experiance && `${Experiance} in Practice`}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardView;
